import { Button } from '@/components/ui/Button';
import { ROUTES } from '@/config/const';
import { useNavigate } from 'react-router-dom';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <section className='flex items-center h-full py-20'>
      <div className='container text-center'>
        <h2 className='mb-8 font-extrabold text-9xl'>
          <span className='sr-only'>Error</span>404
        </h2>
        <p className='text-2xl font-semibold md:text-3xl'>
          Sorry, we couldn&apos;t find this page.
        </p>
        <p className='mt-4 mb-8'>
          But don&apos;t worry, you can find plenty of other things on our dashboard.
        </p>
        <Button variant='link' size='lg' onClick={() => navigate(ROUTES.dashboard)}>
          Back to dashboard
        </Button>
      </div>
    </section>
  );
};

export default NotFoundPage;
